
// este archivo es de los aspirantes que contestaron cada examen

import { Card, Col } from 'antd'
import React from 'react'
import useReporteAspirantesExamen from '../hooks/adminexamen/useReporteAspirantesExamen'

const ReporteAspirantesExamen = () => {

    const { datosAA, pluralSingular, reporteAspirantePorAplicacion} = useReporteAspirantesExamen()


    return (
        <>
            { datosAA.map( (e, i) => (
                <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ i } style={{ marginBottom: 10 }}>

                    <Card
                        hoverable
                        size='default'
                        title={ e.fecha }
                        onClick={ () => reporteAspirantePorAplicacion( e.fecha_sin_formato ) }
                    >
                        { pluralSingular( e.cantidad ) }
                    </Card>

                </Col>
            ))}
        </>
    )
}

export default ReporteAspirantesExamen

